module.exports = __webpack_public_path__ + "static/homepage_blue-be334d06639555283891fa3bf4804144.png";